<template>
  <div>
    <BaseFrame
      saveText='保存'
      logText='操作日志'
      :infosArr='titleInfo'
      :idText='idText'
      :id='id'
      @save='handleSave'
      @hanldeLog='getRecord'
      @clear="clearAll"
      :logData='records'
    >
      <div slot="content" >
          <div class='cardContainer'>
            <lk-card title='基础商品信息'>
              <lk-form  :label-width='134' label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="商品类型:" prop='typeId' class='ivu-form-item-required'>
                      <goodsTypeCascader v-model='typeId' :disabled='true'></goodsTypeCascader>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>
        <div >
          <Drug v-model="info.goodsBase" ref="baseInfo"></Drug>
        </div>
      </div>
    </BaseFrame>
      <DTPModal v-model.trim="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'></DTPModal>
  </div>
</template>

<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import Drug from '../../../components/goods/baseGoods/DrugEdit.vue';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';
import DTPModal from '../../../components/DTPModal.vue';
import goods from '../../../services/goods';
import utils from '../../../libs/utils';
import goodsMixins from '../../../mixins/goodsMixins';


export default {
  name: 'MedicationEdit',
  mixins: [goodsMixins],
  components: {
    BaseFrame,
    Drug,
    DTPModal,
    goodsTypeCascader,
  },
  watch: {
  },
  computed: {
  },
  data() {
    return {
      records: [],
      idText: '',
      id: '',
      titleInfo: [],
      clearModal: false,
      typeId: null,
      info: {},
    };
  },
  methods: {
    clearAll() {
      this.clearModal = true;
    },
    reset() {
      this.getData();
      this.clearModal = false;
    },
    getRecord() {
      this.$store.commit('setDisableLoading', true);
      goods.getBaseRecord({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      goods.getGoodsBaseById({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.typeId = data.goodsBase.type;
          this.info = data;
          this.idText = '商品ID';
          this.id = data.goodsBase.drugSerialCode;
          this.titleInfo = [
            { name: '商品通用名：', value: data.goodsBase.approvedDrugNames },
            { name: '创建人：', value: data.goodsBase.createUserName },
            { name: '创建时间：', value: data.goodsBase.createTime ? utils.exchangeTimeToSecond(data.goodsBase.createTime) : '' },
            { name: '最后修改人：', value: data.goodsBase.modifiedUserName },
            { name: '最后修改时间：', value: data.goodsBase.modifiedTime ? utils.exchangeTimeToSecond(data.goodsBase.modifiedTime) : '' },
          ];
          setTimeout(() => {
            this.$store.commit('setLeaveModal', false);
          }, 200);
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    handleSave() {
      const temp = utils.deepClone(this.info);
      goods.updateGoodsBase(temp).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.$store.commit('setLeaveModal', false);
          this.$router.push({ name: 'goodsBaseList', params: { create: !this.$route.params.id } });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }
  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
</style>
